import { useMutation } from '@tanstack/react-query';

import type { DeclineBatchEventsParams } from 'app/Domain/Connections/Services/ProcessesService';
import { processesService } from 'app/Domain/Connections/Services/ProcessesService';

export type ProcessDeclineEventsData = DeclineBatchEventsParams;

const mutationFn = (data: ProcessDeclineEventsData) => {
  return processesService.declineBatchEvents(data);
};

export const useProcessDeclineEventsMutation = () => {
  return useMutation<unknown, unknown, ProcessDeclineEventsData>(mutationFn);
};
